import React, { ReactElement } from 'react';

/**
 * @param prefix text to render before bolded string
 * @param boldedText bolded text in middle of string
 * @param suffix text to render after bolded string
 * @returns span with boldedText bolded and separated by space from prefix and suffix
 */
export const renderInlineBoldedWordText = (prefix: string, boldedText: string, suffix: string): ReactElement => (
  <span>
    {prefix}
    &nbsp;
    <strong>{boldedText}</strong>
    &nbsp;
    {suffix}
  </span>
);
